(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire08d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire08d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jC8QR", function(module, exports) {

$parcel$export(module.exports, "MAPBOX_STYLE", () => $e4786eabed2e68b3$export$968062a7427b447c);
$parcel$export(module.exports, "loadScriptOnce", () => $e4786eabed2e68b3$export$d44d937b91eda530);
$parcel$export(module.exports, "loadMapboxGl", () => $e4786eabed2e68b3$export$1d1707c1ad510e57);
$parcel$export(module.exports, "whenIdle", () => $e4786eabed2e68b3$export$4d9952dcbf5b2792);
// Shared Mapbox GL loader — used by both explorer.js (per-city list/map page)
// and studio.js (single studio template page). Mapbox GL is loaded LAZILY from the
// CDN on first call; it must NOT be added as a blocking <script> in the Webflow
// <head>, or the ~460 KB + eval lands back on the critical path.
//
// Supercluster is intentionally NOT loaded here — only the list page clusters,
// so it loads supercluster separately alongside loadMapboxGl().
const $e4786eabed2e68b3$export$3120cc2ed1152f2f = "pk.eyJ1IjoibWFydGVuYWxmYWtpcmxhcnNzb24iLCJhIjoiY211dXl6a3B5MHU1dDJ3cGx4ZDBheWk0cCJ9.knhvk3JqaLC1eChr9A_pgA";
const $e4786eabed2e68b3$export$968062a7427b447c = "mapbox://styles/martenalfakirlarsson/cmuv2mvzq00by01s84bpv1c53";
const $e4786eabed2e68b3$export$fbd1063a36bc1ec3 = "https://api.mapbox.com/mapbox-gl-js/v3.21.0/mapbox-gl.js";
const $e4786eabed2e68b3$export$b7d072d0741a29b3 = "https://api.mapbox.com/mapbox-gl-js/v3.21.0/mapbox-gl.css";
function $e4786eabed2e68b3$export$d44d937b91eda530(src) {
    return new Promise((resolve, reject)=>{
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
            if (existing.dataset.loaded === "true") return resolve();
            existing.addEventListener("load", ()=>resolve(), {
                once: true
            });
            existing.addEventListener("error", reject, {
                once: true
            });
            return;
        }
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.addEventListener("load", ()=>{
            script.dataset.loaded = "true";
            resolve();
        }, {
            once: true
        });
        script.addEventListener("error", reject, {
            once: true
        });
        document.head.appendChild(script);
    });
}
function $e4786eabed2e68b3$export$9711875b861d5092(href) {
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
}
// Loads mapbox-gl (+ its CSS) on first call and caches the promise so every
// caller awaits the same single load. Sets the access token once ready and
// resolves with the global `mapboxgl`.
let $e4786eabed2e68b3$var$mapboxGlPromise = null;
function $e4786eabed2e68b3$export$1d1707c1ad510e57() {
    if ($e4786eabed2e68b3$var$mapboxGlPromise) return $e4786eabed2e68b3$var$mapboxGlPromise;
    $e4786eabed2e68b3$var$mapboxGlPromise = (async ()=>{
        $e4786eabed2e68b3$export$9711875b861d5092($e4786eabed2e68b3$export$b7d072d0741a29b3);
        if (!window.mapboxgl) await $e4786eabed2e68b3$export$d44d937b91eda530($e4786eabed2e68b3$export$fbd1063a36bc1ec3);
        const mapboxgl = window.mapboxgl;
        if (!mapboxgl) throw new Error("[mapbox] mapbox-gl failed to load from the CDN.");
        mapboxgl.accessToken = $e4786eabed2e68b3$export$3120cc2ed1152f2f;
        return mapboxgl;
    })();
    return $e4786eabed2e68b3$var$mapboxGlPromise;
}
function $e4786eabed2e68b3$export$4d9952dcbf5b2792(cb) {
    if (typeof requestIdleCallback === "function") requestIdleCallback(cb, {
        timeout: 2000
    });
    else setTimeout(cb, 200);
}

});

parcelRegister("fxPUT", function(module, exports) {

$parcel$export(module.exports, "directionsHref", () => $b512359f36887712$export$c9ffbdbd8b130ecc);
/**
 * Directions Links
 *
 * Upgrades any authored "Directions" link so it opens the visitor's most
 * likely map app (Apple Maps on iOS/macOS, Google Maps elsewhere, or a
 * provider the visitor explicitly chose). Works on any page, inside CMS
 * items, sliders and components — it's attribute-driven, not component-bound.
 *
 * Markup:
 *   <a href="https://www.google.com/maps/dir/?api=1&destination=55.6,13.0"
 *      data-directions
 *      data-directions-lat="55.6" data-directions-lng="13.0"
 *      data-directions-name="Bruce Malmö">Directions</a>
 *
 *   Author a real Google URL as the static href (bind CMS lat/lng into it) so
 *   the link is correct with JS off; this module only rewrites it.
 *
 * Optional per-link attributes:
 *   - data-directions-provider="apple|google|waze"  force a provider
 *   - data-directions-mode="place"                  open a pin on the location
 *                                                   instead of a route from
 *                                                   the visitor's position
 *
 * Optional chooser (any clickable element):
 *   <button data-directions-choose="apple">Apple Maps</button>
 *   Stores the choice in localStorage and re-upgrades every link on the page.
 *
 * Resolution order: per-link provider → stored choice → platform default.
 *
 * Links are upgraded on DOM ready and again whenever new [data-directions]
 * nodes are inserted (Finsweet re-renders, slider clones), via a
 * MutationObserver. The href *attribute* is set (not the .href property) so
 * middle-click, right-click and assistive tech see the final URL.
 */ 
var $bQkhO = parcelRequire("bQkhO");
const $b512359f36887712$var$LINK = "[data-directions]";
const $b512359f36887712$var$CHOOSER = "[data-directions-choose]";
const $b512359f36887712$var$STORAGE_KEY = "bruce:mapProvider";
function $b512359f36887712$var$readStoredProvider() {
    try {
        return localStorage.getItem($b512359f36887712$var$STORAGE_KEY);
    } catch  {
        return null;
    }
}
function $b512359f36887712$var$writeStoredProvider(provider) {
    try {
        if (provider) localStorage.setItem($b512359f36887712$var$STORAGE_KEY, provider);
        else localStorage.removeItem($b512359f36887712$var$STORAGE_KEY);
    } catch  {
    /* private mode / storage disabled — choice just won't persist */ }
}
function $b512359f36887712$export$c9ffbdbd8b130ecc(dest, { provider: provider, mode: mode } = {}) {
    const resolved = (0, $bQkhO.resolveProvider)({
        override: provider,
        stored: $b512359f36887712$var$readStoredProvider(),
        isApple: (0, $bQkhO.isApplePlatform)(navigator)
    });
    return (0, $bQkhO.buildDirectionsUrl)(resolved, dest, {
        mode: (0, $bQkhO.normalizeMode)(mode)
    });
}
function $b512359f36887712$export$8fd1976526b35e14(root = document) {
    root.querySelectorAll($b512359f36887712$var$LINK).forEach($b512359f36887712$var$upgradeLink);
}
function $b512359f36887712$var$upgradeLink(link) {
    const coords = (0, $bQkhO.parseCoords)(link.getAttribute("data-directions-lat"), link.getAttribute("data-directions-lng"));
    if (!coords) return;
    const name = link.getAttribute("data-directions-name") || undefined;
    const provider = link.getAttribute("data-directions-provider");
    const mode = link.getAttribute("data-directions-mode");
    link.setAttribute("href", $b512359f36887712$export$c9ffbdbd8b130ecc({
        ...coords,
        name: name
    }, {
        provider: provider,
        mode: mode
    }));
}
function $b512359f36887712$var$setupChooser() {
    document.addEventListener("click", (e)=>{
        const target = /** @type {Element | null} */ e.target;
        const el = target?.closest?.($b512359f36887712$var$CHOOSER);
        if (!el) return;
        const provider = (0, $bQkhO.normalizeProvider)(el.getAttribute("data-directions-choose"));
        $b512359f36887712$var$writeStoredProvider(provider);
        $b512359f36887712$export$8fd1976526b35e14();
        document.dispatchEvent(new CustomEvent("directions:provider", {
            detail: {
                provider: provider
            }
        }));
    });
}
function $b512359f36887712$var$observeInsertions() {
    if (typeof MutationObserver !== "function") return;
    const observer = new MutationObserver((mutations)=>{
        for (const m of mutations)for (const node of m.addedNodes){
            if (!(node instanceof Element)) continue;
            if (node.matches($b512359f36887712$var$LINK)) $b512359f36887712$var$upgradeLink(node);
            $b512359f36887712$export$8fd1976526b35e14(node);
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
// studio.js is a separate Parcel entry that also imports this module, so on
// the studio page two bundles evaluate it. Init once per page.
const $b512359f36887712$var$INIT_FLAG = "__bruceDirectionsInit";
function $b512359f36887712$var$init() {
    if (window[$b512359f36887712$var$INIT_FLAG]) return;
    window[$b512359f36887712$var$INIT_FLAG] = true;
    $b512359f36887712$export$8fd1976526b35e14();
    $b512359f36887712$var$setupChooser();
    $b512359f36887712$var$observeInsertions();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $b512359f36887712$var$init, {
    once: true
});
else $b512359f36887712$var$init();

});
parcelRegister("bQkhO", function(module, exports) {

$parcel$export(module.exports, "normalizeProvider", () => $89f4497c1f0fbbd7$export$b1276c07738d6325);
$parcel$export(module.exports, "resolveProvider", () => $89f4497c1f0fbbd7$export$15e3fc6f1916b634);
$parcel$export(module.exports, "isApplePlatform", () => $89f4497c1f0fbbd7$export$5775b3f9d1a43b3d);
$parcel$export(module.exports, "buildDirectionsUrl", () => $89f4497c1f0fbbd7$export$850bfafcd0246112);
$parcel$export(module.exports, "normalizeMode", () => $89f4497c1f0fbbd7$export$6926ae187ee400be);
$parcel$export(module.exports, "parseCoords", () => $89f4497c1f0fbbd7$export$93ac7bc215bb896c);
/**
 * Directions URL — pure helpers for directions.js (and studio.js)
 *
 * Framework-free (no DOM, no imports) so the provider-resolution + URL-building
 * logic is unit-testable in Node. The DOM shell lives in directions.js. (Same
 * split as membership-pricing-format.js ↔ membership-pricing.js.)
 *
 * Browsers expose no "preferred map app" — the best available signal is the
 * platform (Apple devices ship Apple Maps; everything else defaults to Google
 * Maps), optionally overridden by an explicit per-link provider or a choice the
 * user made earlier that we stored.
 */ const $89f4497c1f0fbbd7$export$b35c40687956bf9e = [
    "apple",
    "google",
    "waze"
];
function $89f4497c1f0fbbd7$export$b1276c07738d6325(value) {
    const v = (value || "").trim().toLowerCase();
    return $89f4497c1f0fbbd7$export$b35c40687956bf9e.includes(v) ? /** @type {any} */ v : null;
}
function $89f4497c1f0fbbd7$export$15e3fc6f1916b634({ override: override, stored: stored, isApple: isApple }) {
    return $89f4497c1f0fbbd7$export$b1276c07738d6325(override) || $89f4497c1f0fbbd7$export$b1276c07738d6325(stored) || (isApple ? "apple" : "google");
}
function $89f4497c1f0fbbd7$export$5775b3f9d1a43b3d(nav) {
    const platform = nav?.userAgentData?.platform;
    if (platform) {
        const p = platform.toLowerCase();
        return p === "macos" || p === "ios";
    }
    return /iPhone|iPad|iPod|Macintosh|Mac OS X/.test(nav?.userAgent || "");
}
function $89f4497c1f0fbbd7$export$850bfafcd0246112(provider, { lat: lat, lng: lng, name: name }, { mode: mode = "directions" } = {}) {
    const ll = `${lat},${lng}`;
    const place = mode === "place";
    switch(provider){
        case "apple":
            {
                const params = place ? new URLSearchParams({
                    ll: ll
                }) : new URLSearchParams({
                    daddr: ll,
                    dirflg: "d"
                });
                if (name) params.set("q", name);
                return `https://maps.apple.com/?${params}`;
            }
        case "waze":
            {
                const params = new URLSearchParams({
                    ll: ll
                });
                if (!place) params.set("navigate", "yes");
                return `https://waze.com/ul?${params}`;
            }
        default:
            {
                if (place) {
                    const params = new URLSearchParams({
                        api: "1",
                        query: ll
                    });
                    return `https://www.google.com/maps/search/?${params}`;
                }
                const params = new URLSearchParams({
                    api: "1",
                    destination: ll
                });
                return `https://www.google.com/maps/dir/?${params}`;
            }
    }
}
function $89f4497c1f0fbbd7$export$6926ae187ee400be(value) {
    return (value || "").trim().toLowerCase() === "place" ? "place" : "directions";
}
function $89f4497c1f0fbbd7$export$93ac7bc215bb896c(lat, lng) {
    const la = parseFloat(lat ?? "");
    const ln = parseFloat(lng ?? "");
    if (!Number.isFinite(la) || !Number.isFinite(ln)) return null;
    return {
        lat: la,
        lng: ln
    };
}

});


// Studio template page — renders a single Mapbox GL map centered on the
// studio's location. This is the CMS *template* page for one studio (singular
// `data-studio-*` namespace), distinct from explorer.js which powers the
// filterable per-city list/map of studios.
//
// Mapbox GL is loaded LAZILY by the shared ./mapbox.js loader the first time
// the map scrolls into view — it must NOT be a blocking <script> in the Webflow
// <head>. The module self-runs on DOM ready and no-ops on pages without the
// map container, so it's safe to ship site-wide.

var $jC8QR = parcelRequire("jC8QR");

var $fxPUT = parcelRequire("fxPUT");
const $50163f2c57629b3f$var$S = {
    component: '[data-studio-element="component"]',
    mapTarget: '[data-studio-element="map-target"]',
    marker: '[data-studio-element="marker"]',
    directions: '[data-studio-element="directions"]',
    lat: '[data-studio-field="lat"]',
    lng: '[data-studio-field="lng"]',
    name: '[data-studio-field="name"]'
};
const $50163f2c57629b3f$var$MAP_ZOOM = 13;
// Reads the studio's coordinates from the CMS-bound text elements inside the
// component. Returns [lng, lat] (Mapbox order) or null if missing/invalid.
function $50163f2c57629b3f$var$readCoords(component) {
    const latEl = component.querySelector($50163f2c57629b3f$var$S.lat);
    const lngEl = component.querySelector($50163f2c57629b3f$var$S.lng);
    if (!latEl || !lngEl) {
        console.warn(`[studio-map] Missing ${$50163f2c57629b3f$var$S.lat} / ${$50163f2c57629b3f$var$S.lng} inside`, component);
        return null;
    }
    const lat = parseFloat(latEl.textContent);
    const lng = parseFloat(lngEl.textContent);
    if (isNaN(lat) || isNaN(lng)) {
        console.warn(`[studio-map] Non-numeric lat/lng ("${latEl.textContent}", "${lngEl.textContent}")`);
        return null;
    }
    return [
        lng,
        lat
    ];
}
// Points every authored directions link at the studio. Multiple copies are
// expected (e.g. a desktop and a mobile button), so set them all. Provider
// resolution (Apple/Google/Waze, stored preference) is shared with the
// attribute-driven [data-directions] links via ./directions.js. Sets the
// href attribute (not just the .href property) so it works on any element and
// keeps native middle-click / right-click / accessibility intact.
function $50163f2c57629b3f$var$setupDirectionsLinks(component, coords) {
    const links = component.querySelectorAll($50163f2c57629b3f$var$S.directions);
    if (!links.length) return;
    const name = component.querySelector($50163f2c57629b3f$var$S.name)?.textContent.trim() || undefined;
    const [lng, lat] = coords;
    const url = (0, $fxPUT.directionsHref)({
        lat: lat,
        lng: lng,
        name: name
    });
    links.forEach((link)=>link.setAttribute("href", url));
}
// Marker element: a clone of the authored [data-studio-element="marker"]
// template if present, otherwise Mapbox's default pin. Cloning (vs moving)
// keeps the Designer source intact and strips its display:none / hooks.
function $50163f2c57629b3f$var$buildMarkerElement(component) {
    const template = component.querySelector($50163f2c57629b3f$var$S.marker);
    if (!template) return null;
    const clone = template.cloneNode(true);
    if (clone instanceof HTMLElement) {
        clone.style.display = "";
        clone.removeAttribute("data-studio-element");
    }
    return clone;
}
function $50163f2c57629b3f$var$initMap(component, mapTarget, coords) {
    (0, $jC8QR.loadMapboxGl)().then((mapboxgl)=>{
        const map = new mapboxgl.Map({
            container: mapTarget,
            style: (0, $jC8QR.MAPBOX_STYLE),
            projection: "globe",
            center: coords,
            zoom: $50163f2c57629b3f$var$MAP_ZOOM,
            attributionControl: false
        });
        map.addControl(new mapboxgl.AttributionControl({
            compact: true
        }));
        const markerEl = $50163f2c57629b3f$var$buildMarkerElement(component);
        const marker = markerEl ? new mapboxgl.Marker({
            element: markerEl,
            anchor: "center"
        }) : new mapboxgl.Marker();
        marker.setLngLat(coords).addTo(map);
    }).catch((err)=>console.error(err));
}
// Build the map the first time its container nears the viewport. Deferring to
// idle keeps mapbox-gl's parse/eval out of the post-FCP TBT window; the 200px
// rootMargin warms it just before it's scrolled into view.
function $50163f2c57629b3f$var$setupStudioMap(component, mapTarget, coords) {
    const observer = new IntersectionObserver((entries)=>{
        if (!entries.some((entry)=>entry.isIntersecting)) return;
        observer.disconnect();
        (0, $jC8QR.whenIdle)(()=>$50163f2c57629b3f$var$initMap(component, mapTarget, coords));
    }, {
        rootMargin: "200px"
    });
    observer.observe(mapTarget);
}
function $50163f2c57629b3f$var$init() {
    const component = document.querySelector($50163f2c57629b3f$var$S.component);
    if (!component) return;
    const coords = $50163f2c57629b3f$var$readCoords(component);
    if (!coords) return;
    // Directions link is independent of the map — wire it immediately so it
    // works even if the map never scrolls into view.
    $50163f2c57629b3f$var$setupDirectionsLinks(component, coords);
    const mapTarget = component.querySelector($50163f2c57629b3f$var$S.mapTarget);
    if (!mapTarget) {
        console.warn(`[studio-map] Missing ${$50163f2c57629b3f$var$S.mapTarget} inside`, component);
        return;
    }
    $50163f2c57629b3f$var$setupStudioMap(component, mapTarget, coords);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $50163f2c57629b3f$var$init, {
    once: true
});
else $50163f2c57629b3f$var$init();

})();
//# sourceMappingURL=studio.js.map
